import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {DockedPanel} from '../contexts/DockedPanelContext'
import {useMergeStatusButtonData} from '../hooks/use-merge-status-button-data'
import type {MergeStatusButtonData} from '../page-data/payloads/header'
import type {PullRequest} from '../types'
import {useMemo} from 'react'

export function useDetermineDockedPanels({
  pullRequest,
  mergeStatusButtonData,
}: {
  pullRequest: PullRequest
  mergeStatusButtonData?: MergeStatusButtonData
}): DockedPanel[] {
  const validatedMergeData = useMergeStatusButtonData(pullRequest.state, mergeStatusButtonData)
  const hasMergeStatus = !!validatedMergeData

  return useMemo(() => {
    const enabledPanels: DockedPanel[] = ['alerts', 'comments', 'overview'] // always enabled

    if (hasMergeStatus) enabledPanels.push('mergeStatus')
    if (isFeatureEnabled('prs_overview_panel')) {
      enabledPanels.push('info')
      enabledPanels.push('timeline')
    }
    if (isFeatureEnabled('coding_agent_logs_in_pr')) enabledPanels.push('agentSessions')
    if (isFeatureEnabled('copilot_chat_docked_panel')) enabledPanels.push('copilotChat')

    return enabledPanels.sort((a, b) => a.localeCompare(b))
  }, [hasMergeStatus])
}
